import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../helpers'
import { useEffect } from 'react'

const authors: ReadonlyArray<{
  avatar: string
  name: string
  description: string
}> = [
  {
    avatar: '/media/avatars/300-6.jpg',
    name: 'Emma Smith',
    description: 'Project Manager',
  },

  {
    avatar: '/media/avatars/300-5.jpg',
    name: 'Sean Bean',
    description: 'PHP, SQLite, Artisan CLI',
  },

  {
    avatar: '/media/avatars/300-11.jpg',
    name: 'Brian Cox',
    description: 'HTML5, jQuery, CSS3',
  },

  {
    avatar: '/media/avatars/300-23.jpg',
    name: 'Dan Wilson',
    description: 'MangoDB, Java',
  },

  {
    avatar: '/media/avatars/300-10.jpg',
    name: 'Natali Trump',
    description: 'NET, Oracle, MySQL',
  },

  {
    avatar: '/media/avatars/300-9.jpg',
    name: 'Francis Mitcham',
    description: 'React, Vue',
  },

  {
    avatar: '/media/avatars/300-12.jpg',
    name: 'Jessie Clarcson',
    description: 'Angular, React',
  },
]

const AuthorsTab = () => {
  return (
    <div className='mx-5'>

    </div>
  )
}

export {AuthorsTab}
